import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
  [ModulesConfigMap[ModulesMap.NOTIFICATIONS].GET_NOTIFICATIONS]: {
    url: '/company/:companyId/notifications/',
  },
  [ModulesConfigMap[ModulesMap.NOTIFICATIONS].PATCH_NOTIFICATIONS_MARK_ALL_READ]: {
    url: '/company/:companyId/notifications/mark_read_status/',
    requestOptions: {
      method: 'PATCH',
    }
  },
  [ModulesConfigMap[ModulesMap.NOTIFICATIONS].PATCH_NOTIFICATIONS_MARK_READ_STATUS]: {
    url: '/company/:companyId/notifications/mark_read_status/',
    requestOptions: {
      method: 'PATCH',
    }
  },
  [ModulesConfigMap[ModulesMap.NOTIFICATIONS].GET_NOTIFICATIONS_UNREAD_COUNT]: {
    url: '/company/:companyId/notifications/unread_count/',
  },
  [ModulesConfigMap[ModulesMap.NOTIFICATIONS].GET_NOTIFICATION]: {
    url: '/company/:companyId/notifications/:notificationId/',
  },
  [ModulesConfigMap[ModulesMap.NOTIFICATIONS].PATCH_NOTIFICATION]: {
    url: '/company/:companyId/notifications/:notificationId/',
    requestOptions: {
      method: 'PATCH',
    }
  },
  [ModulesConfigMap[ModulesMap.NOTIFICATIONS].GET_NOTIFICATION_PREVIEW]: {
    url: '/company/:companyId/notifications/:notificationId/preview/',
  },
  [ModulesConfigMap[ModulesMap.NOTIFICATIONS].GET_NOTIFICATIONS_SETTINGS]: {
    url: '/company/:companyId/notifications/settings/',
  },
  [ModulesConfigMap[ModulesMap.NOTIFICATIONS].PATCH_NOTIFICATIONS_SETTINGS]: {
    url: '/company/:companyId/notifications/settings/:notificationSettingId/',
    requestOptions: {
      method: 'PATCH',
    }
  },
}










